<div class="min-h-screen surface-ground flex flex-column justify-content-between text-sm">


  <!-- Header -->
  <header class="surface-900 text-white p-3">
    <div class="md:w-8 mx-auto flex align-items-center justify-content-between">
      <img width="250" src="/assets/img/ufp-logo-white.svg" alt="Logo" />
      <p-button label="Contact Support" icon="fa fa-cog" styleClass="text-sm" (click)="showSupportPopup=true" />
    </div>
  </header>
  <!-- Header -->

  <!-- Content -->
  <div class="p-4 text-center md:w-5 mx-auto">
    <img width="300" src="/assets/img/error-img.svg" alt="Error Image" />
    <h1 class="text-xl md:text-2xl my-3">Oops! We cannot find any organization with the provided url address.</h1>

    <div class="p-inputgroup mx-auto">
      <span class="p-inputgroup-addon">You entered</span>
      <input class="pointer-events-none" pInputText [value]="domainUrl" />
    </div>

    <p class="md:mt-8 my-3">If you have forgotten your address <br class="md:hidden"> you can get in touch with us</p>
    <p-button label="Contact Support" icon="fa fa-cog" styleClass="text-sm p-button-outlined surface-0" (click)="showSupportPopup=true" />
  </div>
  <!-- Content -->

  <!-- Footer -->
  <footer class="surface-0 flex align-items-center justify-content-center p-3">
    <span class="mr-2"><img class="footer-logo" src="assets/img/fitness-force.jpg" alt="Fitness Force"
    width="37"></span>
    <div>
      <p class="mb-1">© FitnessForce. v2.3.3</p>
      <ul class="list-inline flex list-none mb-0 text-xs opacity-70 pl-0 mt-2">
        <li class="mr-3"><a href="#" class="text-600 no-underline hover:text-primary">Terms of Use</a></li>
        <li><a href="#" class="text-600 no-underline hover:text-primary">Privacy Policy</a></li>
      </ul>
    </div>
  </footer>
  <!-- Footer -->

</div>

@if (showSupportPopup) {
  <app-help-support [visibility]="showSupportPopup" (closeDialog)="closeSupportDialog($event)" />
}
